(function () {
    'use strict';

    angular
        .module('managePairing')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('managePairing', {
                url: '/manage-pairing/:patternId?',
                params: {
                    patternId: null
                },
                views: {
                    'managePairingView': {
                        templateUrl: 'manage-pairing/views/manage-pairing.tpl.html',
                        controller: 'ManagePairingCtrl',
                        controllerAs: 'managePairing'
                    }
                }
            });
    }
}());
